import Button from "@mostrans/web-components/components/base/Button";
import Input from "@mostrans/web-components/components/base/Input";
import { Dialog, Grid, Paper, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import Cards from "../../../components/Card/Cards";
import Filter from "../../../components/Filter/Filter";

function JobLists() {
  const media = useMediaQuery("(max-width:1000px)");
  const [openFilter, setOpenFilter] = useState(false);
  const [searchName, setSearchName] = useState();

  const handleClose = () => {
    setOpenFilter(false);
  };
  return (
    <React.Fragment>
      <Paper variant="outlined" component="div" sx={{ m: media && 1.5 }}>
        <form className=" justify-content-center" style={{ margin: "10px" }}>
          <Input
            type="text"
            onChange={(e) => setSearchName(e.target.value.toLowerCase())}
            placeholder="Driver, Finance, etc"
            style={{
              width: media ? "100%" : "85%",
              marginBottom: media && "10px",
            }}
          />
          <Button
            onClick={() => setOpenFilter(true)}
            variant="contained"
            color="inherit"
            style={{
              marginRight: "10px",
              width: media && "100%",
              display: media ? "" : "none",
            }}>
            <span className="material-icons"> tune </span>
          </Button>
          <Button
            className="button-search"
            variant="contained"
            color="primary"
            style={{
              marginLeft: media ? "" : "10px",
              width: media ? "100%" : "13%",
              marginTop: media && "10px",
            }}>
            Search Jobs
          </Button>
          <Dialog
            open={openFilter}
            onClose={handleClose}
            style={{ width: "auto", margin: "auto" }}>
            <div className="dialog-filter">
              <Filter
                open={openFilter}
                handleClose={handleClose}
                setOpen={setOpenFilter}
              />
            </div>
          </Dialog>
        </form>
      </Paper>
      <Grid container>
        <Grid
          item
          xl={2.5}
          lg={2.5}
          md={4}
          sm={8}
          sx={{
            marginY: "15px",
            display: media && "none",
            paddingRight: "20px",
          }}>
          <Filter />
        </Grid>
        <Grid
          item
          xl={9.5}
          lg={9.5}
          md={media ? 12 : 8}
          sm={12}
          sx={{ overflow: "scroll", height: media && "500px" }}>
          <Cards search={searchName} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default JobLists;
